<template>
  <gtPLP
    ref="plp"
    :key="$route.path"
    class="gt-plp-page"
    :preview-data="{ ...previewData, conditionKeyword }"
    :category-code="categoryCode"
    :category-ext-code="categoryExtCode"
    :water-fall-options="waterFallOptions"
    :wcm-columns="wcmColumns ? wcmColumns : 4"
    :use-catalog-product="useCatalogProduct"
    :hidden-end="true"
    :priority-wcm-column="true"
    :condition-keyword="conditionKeyword"
    :hidden-filter="true"
    :params="{ ...params, categoryExtCode }"
    :class="
      isMobile
        ? `mobile-product-list-columns-${wcmColumns || 2}`
        : `product-list-columns-${wcmColumns || 4}`
    "
    :distance="getBottomDistance"
    :need-scroll-load="needScrollLoad"
    :h5-need-scroll-load="needScrollLoad"
    :after-load-more="afterLoadMore"
  >
    <div slot="skeleton-item"></div>
    <template v-if="isMobile" slot="list-top" slot-scope="{ totalCount, dataList }">
      <div v-if="(dataList && dataList.length) || totalCount" class="plp-list_top">
        <!-- <img
          alt="plp"
          style="width: 100%"
          src="https://static.gtech.asia/dev/200005/20230615/AD9ECE553878E2AE5479EABC989938DD.png?x-oss-process=image/format,webp"
        /> -->
        <!-- <img v-if="advImgUrl" alt="product-list" style="width: 100%" :src="advImgUrl" />
        <GtBannerAd
          v-else-if="topAd && topAd.length && productDisplayType === 'condition'"
          :data="topAd"
        ></GtBannerAd> -->

        <!-- <Breadcrumb
          v-if="breadcrumbData && breadcrumbData.breadcrumb && breadcrumbData.breadcrumb.length"
          class="plp-top_breadcrumb"
          separator-class="iconfont icon-a-24-1px-right-s"
        >
          <BreadcrumbItem
            v-for="(item, index) in breadcrumbData.breadcrumb"
            :key="index"
            :to="{ path: item.path }"
          >
            {{ item.name }}
          </BreadcrumbItem>
        </Breadcrumb> -->
        <!-- <div v-if="!hiddenFilter || pageTitle" class="page-plp__top">
          <h1 class="title">
            {{ pageTitle }}
          </h1>
          <div v-if="!hiddenFilter" class="sort">{{ totalCount }} 件商品</div>
        </div> -->
      </div>
    </template>
    <template
      slot="plp-top"
      slot-scope="{ onFilter, filterData, totalCount, resetFilterData, dataList }"
    >
      <!-- tips:移除判断 -->
      <!-- 'padding-top': adPageTop.length ? 'unset' : isMobile ? '' : '100px', -->
      <section v-show="dataList && dataList.length" class="slot-page-plp-top">
        <template v-if="!isMobile">
          <Breadcrumb
            v-if="
              breadcrumbData &&
              breadcrumbData.breadcrumb &&
              breadcrumbData.breadcrumb.length &&
              $route.name !== 'plpSearch' &&
              iconVisible
            "
            class="plp-top_breadcrumb"
            separator-class="iconfont icon-a-24-1px-right-s"
          >
            <BreadcrumbItem
              v-for="(item, index) in breadcrumbData.breadcrumb"
              :key="index"
              :to="{ path: item.path }"
            >
              {{ item.name }}
            </BreadcrumbItem>
          </Breadcrumb>

          <!-- categoryList决定筛选项是否显示 -->
          <!-- <div class="page-plp__top" :style="{ 'margin-top': hasBreadcrumb ? '12px' : '64px' }">
          <h1 v-if="conditionKeyword" class="page-search_title">
            “{{ conditionKeyword }}”的相关结果
          </h1>
          <slot v-else name="left-title">
            <h1 class="title">
              {{ pageTitle }}
            </h1>
          </slot>
          <div
            v-if="!hiddenFilter"
            :style="{ 'margin-left': conditionKeyword || pageTitle ? '20px' : '' }"
            class="sort-pc"
          >
            {{ totalCount }} 件商品
          </div>
        </div> -->
        </template>
        <div style="clear: both"></div>
        <div
          :style="{
            'margin-top': isMobile ? '' : $route.name == 'plpSearch' ? '64px' : '12px',
            'margin-bottom': isMobile ? '' : $route.name == 'plpSearch' ? '8px' : '',
            display: showFilterStyle ? 'inline-block' : 'none'
          }"
        >
          <Query-Results-Tips
            :filter-data="filterData"
            :on-filter="onFilter"
            :total-count="totalCount"
            :reset-filter-data="resetFilterData"
            :condition-keyword="conditionKeyword"
            :params="{ ...params, categoryCode, categoryExtCode }"
            :page-title="pageTitle"
            :has-breadcrumb="hasBreadcrumb"
            :is-mobile-prop="isMobile"
            :hidden-filter="hiddenFilter"
          ></Query-Results-Tips>
        </div>
      </section>
    </template>
    <!-- :style="{
          width: `calc(${(100 / wcmColumns) * adOccupiesColumns}% - ${8 * adOccupiesColumns}px`,
          minWidth: `calc(${(100 / wcmColumns) * adOccupiesColumns}% - ${8 * adOccupiesColumns}px`,
          maxWidth: `calc(${(100 / wcmColumns) * adOccupiesColumns}% - ${8 * adOccupiesColumns}px`
        }" -->
    <!-- !isMobile && -->
    <template v-if="((topAd && topAd.length) || advImgUrl) && showAd" slot="banner-left_top">
      <div
        class="waterfall__item banner-item"
        style="padding-right: 0px; display: flex; overflow: hidden"
        :style="{
          'grid-column': `span ${isMobile ? 1 : adOccupiesColumns || 3}`
        }"
      >
        <nuxt-link v-if="advImgUrl" target="_blank" :to="advImgJumpLink" style="width: 100%">
          <img alt="product-list" style="width: 100%" :src="advImgUrl" />
        </nuxt-link>
        <topAd v-else :data="[topAd[0]]"></topAd>
      </div>
      <!-- <div
        v-for="(item, index) in adOccupiesColumns - 1"
        :key="index"
        class="waterfall__item"
        style="border-left: 0px; max-width: 0px; min-width: 0px"
      ></div> -->
    </template>

    <!-- plp 头部 slot -->
    <!-- <template #plp-top>
          <h1>这是top</h1>
        </template> -->

    <!-- plp 每一项item slot -->
    <!-- <template #plp-item="{ item }">
        </template> -->
    <template slot="plp-filter" slot-scope="{ onFilter, filterData, totalCount, resetFilterData }">
      <!-- dataList && dataList.length &&  -->
      <!-- style="z-index: 101" -->
      <div
        v-if="!hiddenFilter"
        class="page-plp-left"
        :style="{
          display: showFilterStyle ? 'inline-block' : 'none'
        }"
      >
        <product-filter-mobile
          v-if="isMobile"
          ref="product-flter-mobile"
          :filter-data="filterData"
          :on-filter="onFilter"
          :total-count="totalCount"
          :reset-filter-data="resetFilterData"
          :condition-keyword="conditionKeyword"
          :params="{ ...params, categoryCode, categoryExtCode }"
          :page-title="pageTitle"
          :show-type-side="
            breadcrumbData && breadcrumbData.breadcrumb && breadcrumbData.breadcrumb.length < 4
          "
          @onSelected="onSelected"
        >
          <h1 v-if="title" slot="left-title" class="title">{{ title }}</h1>
        </product-filter-mobile>
        <product-filter-side
          v-else
          ref="product-flter-side"
          :filter-data="filterData"
          :on-filter="onFilter"
          :total-count="totalCount"
          :reset-filter-data="resetFilterData"
          :condition-keyword="conditionKeyword"
          :params="{ ...params, categoryCode, categoryExtCode }"
          :show-type-side="
            breadcrumbData && breadcrumbData.breadcrumb && breadcrumbData.breadcrumb.length < 4
          "
          @onSelected="onSelected"
        >
          <h1 v-if="title" slot="left-title" class="title">{{ title }}</h1>
        </product-filter-side>
      </div>
      <div></div>
    </template>
    <ProductCard
      slot="plp-item"
      slot-scope="{ data, index, dataList }"
      :index="index"
      :data-list="dataList"
      style="position: relative"
      :has-ad="!!(topAd && topAd.length)"
      :data="data"
      :track-data-nav="trackDataNav"
      :selected-list="selectedList"
    />
    <template slot="nextPageLoading">
      <div class="load-more-main">
        <svg
          class="load-more-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
        >
          <path
            d="M31.8329 24.1818C31.6449 24.3073 31.4569 24.4956 31.2063 24.6211C29.577 25.8134 27.1332 26.6291 24 26.6291H23.8747H23.7493C20.6162 26.6291 18.235 25.8134 16.5431 24.6211C16.2924 24.4328 16.0418 24.3073 15.9165 24.1818C16.1044 24.0563 16.2924 23.8681 16.5431 23.7426C18.1723 22.5503 20.6162 21.7345 23.7493 21.7345H23.8747H24C27.1332 21.7345 29.5144 22.5503 31.2063 23.7426C31.4569 23.8681 31.7076 24.0563 31.8329 24.1818ZM48 14.5181C48 14.5181 46.5588 13.4513 42.1097 11.757C38.1619 10.3138 35.2167 10 35.2167 10V18.5342C35.2167 19.7265 34.9034 20.856 33.9634 22.0483C30.6423 20.856 27.4465 20.103 24 20.103C20.5535 20.103 17.3577 20.856 14.0366 22.0483C13.0966 20.7932 12.7833 19.7265 12.7833 18.5342V10C12.7833 10 9.83812 10.3138 5.89034 11.757C1.37859 13.3886 0 14.5181 0 14.5181C0.18799 18.4087 3.5718 21.7973 8.89817 24.1818C3.5718 26.5664 0.18799 30.0177 0 33.8455C0 33.8455 1.44125 34.9123 5.89034 36.6066C9.83812 38.0499 12.7833 38.3636 12.7833 38.3636V29.8294C12.7833 28.6372 13.0966 27.5076 14.0366 26.3154C17.3577 27.5076 20.5535 28.2607 24 28.2607C27.4465 28.2607 30.6423 27.5076 33.9634 26.3154C34.9034 27.5704 35.2167 28.6372 35.2167 29.8294V38.3636C35.2167 38.3636 38.2245 38.0499 42.1097 36.6066C46.6214 34.9751 48 33.8455 48 33.8455C47.812 29.9549 44.4282 26.5664 39.1018 24.1818C44.4282 21.7973 47.812 18.3459 48 14.5181Z"
            fill="#14141E"
            fill-opacity="0.15"
          />
        </svg>
        <p class="load-more-text">加载更多</p>
      </div>
    </template>
    <template slot="empty">
      <div
        v-if="$route.name === 'plpSearch'"
        class="page-search-empty"
        :class="{ 'page-search-empty-mobile': isMobile }"
      >
        <div class="search-box">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="96"
            height="96"
            viewBox="0 0 96 96"
            fill="none"
          >
            <g clip-path="url(#clip0_3441_16691)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M37.4948 6.17136C36.9385 5.54545 36.0511 5.33244 35.2712 5.6376L0.77122 19.1376C0.183593 19.3675 -0.261055 19.8613 -0.428383 20.4697C-0.59571 21.0782 -0.466091 21.7299 -0.0786854 22.228L9.64748 34.733L-0.288835 54.6057C-0.540134 55.1083 -0.568408 55.6934 -0.366739 56.2179C-0.16507 56.7424 0.247936 57.1578 0.77122 57.3626L35.2712 70.8626C36.1722 71.2151 37.1963 70.8722 37.7033 70.0483L46 56.5662V85.6141L14 73.6141V66.0001H10V75.0001C10 75.8338 10.5172 76.58 11.2978 76.8727L47.2861 90.3683C47.7368 90.5406 48.2404 90.546 48.7023 90.3727L84.7023 76.8727C85.4829 76.58 86 75.8338 86 75.0001V66.0001H82V73.6141L50 85.6141V56.5662L58.2967 70.0483C58.8038 70.8722 59.8279 71.2151 60.7288 70.8626L95.2288 57.3626C95.7521 57.1578 96.1651 56.7424 96.3668 56.2179C96.5685 55.6934 96.5402 55.1083 96.2889 54.6057L86.3526 34.733L96.0787 22.228C96.4661 21.7299 96.5958 21.0782 96.4284 20.4697C96.2611 19.8613 95.8165 19.3675 95.2288 19.1376L60.7288 5.6376C59.949 5.33244 59.0616 5.54545 58.5052 6.17136L48 17.9897L37.4948 6.17136ZM44.5691 20.1507L35.431 9.8704L4.72319 21.8865L12.6754 32.1108L44.5691 20.1507ZM91.2769 21.8865L83.3246 32.1108L51.431 20.1507L60.569 9.8704L91.2769 21.8865ZM83.046 37.0642L50.9303 50.4458L60.8275 66.5286L91.7318 54.4357L83.046 37.0642ZM45.0697 50.4458L12.954 37.0642L4.2683 54.4357L35.1726 66.5286L45.0697 50.4458ZM48 47.3334L17.435 34.598L48 23.1361L78.5651 34.598L48 47.3334Z"
                fill="#14141E"
                fill-opacity="0.1"
              />
            </g>
            <defs>
              <clipPath id="clip0_3441_16691">
                <rect width="96" height="96" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p class="no-find">
            抱歉，没有找到与{{ conditionKeyword ? `"${conditionKeyword}"` : '' }}相关的商品
          </p>
          <p class="again-search">请尝试其他搜索</p>
          <!-- <h3>没有找到与{{ conditionKeyword ? `"${conditionKeyword}"` : '' }}相关的商品</h3>
          <h4>请尝试其他搜索</h4> -->
          <!-- <p>
            <span>• 尝试减少您的搜索条件</span>
            <span>• 试试单个词组搜索</span>
          </p>
          <p>如果问题依然存在，您可以联系我们</p> -->
        </div>

        <div class="plp-precommend">
          <PRecommend :type="0" />
        </div>
        <!-- <div class="breadcrumb">
          <Breadcrumb
            v-if="breadcrumbData && breadcrumbData.breadcrumb.length"
            class="plp-top_breadcrumb"
            separator-class="iconfont icon-arrow-right"
          >
            <BreadcrumbItem
              v-for="(item, index) in breadcrumbData.breadcrumb"
              :key="index"
              :to="{ path: item.path }"
            >
              {{ item.name }}
            </BreadcrumbItem>
          </Breadcrumb>
        </div> -->
      </div>
      <div v-else class="page-search-empty" :class="{ 'page-filter-empty-mobile': isMobile }">
        <div class="plp-dotted-line"></div>
        <div class="search-box">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="96"
            height="96"
            viewBox="0 0 96 96"
            fill="none"
          >
            <g clip-path="url(#clip0_3441_16691)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M37.4948 6.17136C36.9385 5.54545 36.0511 5.33244 35.2712 5.6376L0.77122 19.1376C0.183593 19.3675 -0.261055 19.8613 -0.428383 20.4697C-0.59571 21.0782 -0.466091 21.7299 -0.0786854 22.228L9.64748 34.733L-0.288835 54.6057C-0.540134 55.1083 -0.568408 55.6934 -0.366739 56.2179C-0.16507 56.7424 0.247936 57.1578 0.77122 57.3626L35.2712 70.8626C36.1722 71.2151 37.1963 70.8722 37.7033 70.0483L46 56.5662V85.6141L14 73.6141V66.0001H10V75.0001C10 75.8338 10.5172 76.58 11.2978 76.8727L47.2861 90.3683C47.7368 90.5406 48.2404 90.546 48.7023 90.3727L84.7023 76.8727C85.4829 76.58 86 75.8338 86 75.0001V66.0001H82V73.6141L50 85.6141V56.5662L58.2967 70.0483C58.8038 70.8722 59.8279 71.2151 60.7288 70.8626L95.2288 57.3626C95.7521 57.1578 96.1651 56.7424 96.3668 56.2179C96.5685 55.6934 96.5402 55.1083 96.2889 54.6057L86.3526 34.733L96.0787 22.228C96.4661 21.7299 96.5958 21.0782 96.4284 20.4697C96.2611 19.8613 95.8165 19.3675 95.2288 19.1376L60.7288 5.6376C59.949 5.33244 59.0616 5.54545 58.5052 6.17136L48 17.9897L37.4948 6.17136ZM44.5691 20.1507L35.431 9.8704L4.72319 21.8865L12.6754 32.1108L44.5691 20.1507ZM91.2769 21.8865L83.3246 32.1108L51.431 20.1507L60.569 9.8704L91.2769 21.8865ZM83.046 37.0642L50.9303 50.4458L60.8275 66.5286L91.7318 54.4357L83.046 37.0642ZM45.0697 50.4458L12.954 37.0642L4.2683 54.4357L35.1726 66.5286L45.0697 50.4458ZM48 47.3334L17.435 34.598L48 23.1361L78.5651 34.598L48 47.3334Z"
                fill="#14141E"
                fill-opacity="0.1"
              />
            </g>
            <defs>
              <clipPath id="clip0_3441_16691">
                <rect width="96" height="96" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p>
            <span class="no-find-2">抱歉，没有找到相关商品，请尝试</span>
            <span class="again-search-2" @click="dataEmptyResetFilterData">重新筛选</span>
          </p>
        </div>
        <div class="plp-precommend">
          <PRecommend :type="0" />
        </div>
      </div>
    </template>
  </gtPLP>
</template>

<script>
import { componentsCommon, GtBannerAd } from '@speedshop/template';
import { Breadcrumb, BreadcrumbItem } from 'element-ui';
import { mapState } from 'vuex';
import gtPLP from '@/components/GtPLP/children/plp.vue';
import ProductFilterSide from '@/components/PLP/productFilterSide.vue';
import ProductFilterMobile from '@/components/PLP/productFilterMobile.vue';
import ProductCard from '@/components/PLP/item.vue';
import { CatalogProduct, CatalogWcmProduct } from '@/utils/product';
import PRecommend from '@/components/PLP/PRecommend.vue';
import QueryResultsTips from '@/components/PLP/queryResultsTips.vue';
import topAd from '@/components/LandingPage/topAd.vue';

export default {
  name: 'Plp',
  components: {
    gtPLP,
    topAd,
    ProductCard,
    Breadcrumb,
    BreadcrumbItem,
    GtBannerAd,
    PRecommend,
    ProductFilterSide,
    ProductFilterMobile,
    QueryResultsTips
  },
  mixins: [componentsCommon],
  //   async asyncData({ route }) {
  //     const categoryCode = route.params.category || '';
  //     const conditionKeyword = route.query.searchWord || '';

  //     const plp = CatalogProduct();
  //     const data = await plp.init({
  //       conditionKeyword,
  //       categoryCode,
  //       pageSize: 10,
  //       pageNum: 1,
  //       prefetch: true
  //     });
  //     console.log('plp', plp.filterData);

  //     return {
  //       plp,
  //       data,
  //       conditionKeyword,
  //       categoryCode
  //     };
  //   },
  props: {
    categoryCode: {
      type: String,
      default: ''
    },
    categoryExtCode: {
      type: String,
      default: ''
    },
    previewData: {},
    conditionKeyword: {},
    noDataHidden: {
      default: false
    },
    pageData: {
      type: Object,
      default: () => ({})
    },
    hiddenFilter: {
      type: Boolean,
      default: false
    },
    advImgUrl: {
      type: String,
      default: ''
    },
    advImgJumpLink: {
      type: String,
      default: ''
    },
    wcmColumns: {
      type: Number
    },
    params: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: ''
    },
    adOccupiesColumns: {
      type: Number,
      default: 2
    },
    productDisplayType: {
      type: String,
      default: 'condition'
    },
    isDisplaySort: {
      typ: Boolean,
      default: true
    },
    needScrollLoad: {
      type: Boolean,
      default: true
    },
    showAd: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      selectedList: [],
      plp: null,
      data: {},
      waterFallOptions: {
        gutter: 16,
        breakpoints: {
          768: 2,
          1024: 3
        }
      },
      useCatalogProduct: ['home', 'LandingPage', 'LandingPage-all'].includes(this.$route.name)
        ? CatalogWcmProduct
        : CatalogProduct,
      trackDataNav: {},
      isShowPageTitleByCategoryListLength: false,
      showFilterStyle: false,
      iconVisible: false
    };
  },
  computed: {
    ...mapState(['headerList', 'adData']),
    matchNavData() {
      const url = this.$route.path;
      const list =
        this.headerList.find(i => {
          const stringData = JSON.stringify(i);
          return stringData.includes(url);
        }) || {};
      return list;
    },
    breadcrumbData() {
      if (!this.matchNavData) {
        return {
          nav: [],
          breadcrumb: []
        };
      }
      const { children = [], navigationUrl } = this.matchNavData || {};
      const url = this.$route.path;
      const title =
        this.matchNavData.navigationName +
        (['男子', '女子', '少女'].includes(this.matchNavData.navigationName) ? '装备' : '');
      if (url === navigationUrl) {
        return {
          nav: this.matchNavData,
          breadcrumb: [
            {
              name: '首页',
              path: '/'
            },
            {
              name: title
              // path: this.matchNavData.navigationUrl,
            }
          ]
        };
      } else {
        const secondData = children.find((item, index) => {
          const stringData = JSON.stringify(item);
          return stringData.includes(url);
        });
        if (!secondData) {
          return {
            nav: [],
            breadcrumb: []
          };
        }
        const { children: secondDataChildren = [], navigationUrl } = secondData || {};

        if (navigationUrl === url) {
          return {
            nav: [this.matchNavData, secondData],
            breadcrumb: [
              {
                name: '首页',
                path: '/'
              },
              {
                name: title,
                path: this.matchNavData.navigationUrl
              },
              {
                name: secondData.navigationName
                //  path: secondData.navigationUrl,
              }
            ]
          };
        } else {
          const thirdData =
            secondDataChildren.find(item => {
              const stringData = JSON.stringify(item);
              return stringData.includes(url);
            }) || {};
          return {
            nav: [this.matchNavData, secondData, thirdData],
            breadcrumb: [
              {
                name: '首页',
                path: '/'
              },
              {
                name: title,
                path: this.matchNavData.navigationUrl
              },
              {
                name: secondData.navigationName,
                path: secondData.navigationUrl
              },
              {
                name: thirdData.navigationName
                //  path: thirdData.navigationUrl,
              }
            ]
          };
        }

        //
      }
    },
    topAd() {
      const { PLPBannerWithPosition } = this.adData || {};
      const { top } = PLPBannerWithPosition || {};
      return top;
    },
    pageTitle() {
      const { breadcrumbData: { breadcrumb } = {} } = this;
      const breadcrumbTitle =
        (breadcrumb && breadcrumb.length && breadcrumb[breadcrumb.length - 1].name) || '';
      return this.title
        ? this.title
        : this.conditionKeyword
        ? `“${this.conditionKeyword}”的相关结果`
        : breadcrumbTitle;
    },
    columns() {
      return this.wcmColumns ? this.wcmColumns : this.isMobile ? 2 : 3;
    },
    hasBreadcrumb() {
      const { breadcrumbData } = this;
      return breadcrumbData && breadcrumbData.breadcrumb && breadcrumbData.breadcrumb.length > 0;
    },
    categoryList() {
      const data = (this.filterData && this.filterData.find(i => i.code === 'CATEGORY')) || {};
      function findSecondLastChildrenWithChildren(tree) {
        const secondLastChildrenWithChildren = [];

        function traverse(node, depth) {
          if (!node.list || node.list.length === 0) {
            return;
          }
          const firstChild = node.list[0];

          if (firstChild.list && firstChild.list.length) {
            for (const child of node.list) {
              traverse(child, depth - 1);
            }
          } else {
            secondLastChildrenWithChildren.push(node);
          }

          // if (depth === 1) {
          //   secondLastChildrenWithChildren.push(node);
          //   return;
          // }

          // for (const child of node.list) {
          //   traverse(child, depth - 1);
          // }
        }

        for (const root of tree) {
          traverse(root, 2);
        }

        return secondLastChildrenWithChildren;
      }

      const { list = [], ...others } = data;

      const newList = list.map(item => {
        const children = item.children.map(i => {
          return {
            ...i,
            list: (i.list || i.children || []).map(e => {
              return {
                ...e,
                list: (e.list || e.children || []).map(c => {
                  return {
                    ...c,
                    list: c.list || c.children,
                    name: c.name || c.categoryName
                  };
                }),
                name: e.name || e.categoryName
              };
            }),
            name: i.name || i.categoryName
          };
        });
        return {
          ...item,
          list: children,
          name: item?.name || item.categoryName
        };
      });
      const { categoryCode, categoryCodeList = [] } = this.params || {};
      const filterCategory = [categoryCode, ...categoryCodeList].filter(i => i);
      const secondLastChildrenWithChildren = findSecondLastChildrenWithChildren(newList);
      // 过滤categoryCode
      const filterNoMatchData = secondLastChildrenWithChildren;
      // const filterNoMatchData = !filterCategory.length
      //   ? secondLastChildrenWithChildren
      //   : secondLastChildrenWithChildren.filter(i => {
      //       const matchChildren = i.list.some(c => {
      //         const pathCodeList = c.categoryPath?.split('>') || [];
      //         return filterCategory.some(e => {
      //           return pathCodeList.includes(e);
      //         });
      //       });
      //       return matchChildren;
      //     });
      // 去重
      const myMap = new Map();
      filterNoMatchData.forEach(item => {
        const { name, list } = item;
        if (myMap.has(name)) {
          const data = myMap.get(name);
          list.forEach(i => {
            data.listMap.set(i.name, i);
          });
          myMap.set(name, { ...data, list: newList });
        } else {
          const listMap = new Map();
          list.forEach(i => {
            listMap.set(i.name, i);
          });
          myMap.set(name, { ...item, listMap });
        }
      });
      const newListMap = [...myMap.values()];
      const resultList = newListMap.map(i => {
        return {
          ...i,
          list: [...i.listMap.values()].map(item => {
            return {
              ...item,
              originalCode: item.categoryCode,
              categoryCode: item.name,
              code: item.name,
              attrCate: 'CATEGORY'
            };
          })
        };
      });
      return {
        ...others,
        list: resultList
      };
    },
    adPageTop() {
      const { PageBannerWithPosition = {} } = this.$store.state.adData || {};
      return PageBannerWithPosition.top || [];
    }
  },
  watch: {
    // $route: {
    //   deep: true,
    //   immediate: true,
    //   async handler(val) {
    //     const conditionKeyword = val.query.keyword || '';
    //     if (conditionKeyword && conditionKeyword !== this.conditionKeyword) {
    //       await this.init();
    //     }
    //   }
    // }
    breadcrumbData() {
      this.setNavigationData();
    }
  },
  mounted() {
    this.setNavigationData();
    this.setFilterBarCeilingOption();
    this.$nextTick(() => {
      const dom = document.querySelector('.ua-header-search__drawer-input-self');
      const dom2 = document.querySelector('.sp-landing-page.sp-landingpage-collection > .sp-row'); // 去除样式冲突
      if (dom) {
        const input = dom.querySelector('input');
        input?.blur();
      }
      if (dom2) {
        dom2.style.padding = 0;
      }
    });
    this.$eventBus.$on('drawLoginSuccessCallback', data => {
      this.$refs.plp?.handleRefresh();
    });
    // 浏览器在加载 iconfont 字体文件时比较耗时，导致文字加载了，icon不加载，nextTick全部加载好后，显示面包屑
    this.$nextTick(() => {
      this.iconVisible = true; // 图标显示后，更新图标可见状态
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.listenerScroll);
  },
  methods: {
    async init() {
      //   const categoryCode = this.$route.params.category || '';
      //   const conditionKeyword = this.$route.query.keyword || '';
      //   this.conditionKeyword = conditionKeyword;
      //   this.categoryCode = categoryCode;
      //   const plp = CatalogProduct();
      //   await plp.init({
      //     conditionKeyword,
      //     categoryCode,
      //     pageSize: 10,
      //     pageNum: 1,
      //     prefetch: true
      //   });
      //   this.plp = plp;
    },
    setNavigationData() {
      const nav = this.breadcrumbData?.breadcrumb || [];
      const navigation_primary_category = (nav[1] && nav[1].name) || '';
      const navigation_secondary_category = (nav[2] && nav[2].name) || '';
      const navigation_third_category = (nav[3] && nav[3].name) || '';
      this.trackDataNav = {
        navigation_primary_category,
        navigation_secondary_category,
        navigation_third_category
      };
      this.$previousPage.setPageData({
        navigation_primary_category,
        navigation_secondary_category,
        navigation_third_category
      });
    },
    getBottomDistance() {
      const footerHeight = document.querySelector('.footer')?.offsetHeight || 0;
      const searchHeight = document.querySelector('.hw-search')?.offsetHeight || 0;

      const plpPaddingBottom = 81;
      const searchPaddingBottom = 81;
      const distance = 1400; // 3个product card 的高度
      return plpPaddingBottom + distance + footerHeight + searchHeight + searchPaddingBottom;
    },
    async afterLoadMore() {},
    onSelected(val) {
      this.selectedList = val;
    },
    dataEmptyResetFilterData() {
      if (this.isMobile) {
        this.$refs['product-flter-mobile'].$refs['plp-drawer'].handleClearAll();
      } else if (
        this.$refs['product-flter-side'] &&
        this.$refs['product-flter-side'].$refs['nav-side'] &&
        this.$refs['product-flter-side'].$refs['nav-side'].$refs['plp-drawer']
      ) {
        this.$refs['product-flter-side'].$refs['nav-side'].$refs['plp-drawer'].handleClearAll();
      }
    },
    // setFilterBarCeilingOption() {
    //   const _this = this;
    //   // 监听滚动事件，计算filterbar的吸顶样式
    //   this.observerScroll();
    //   // 设置filterbar和顶部title的padding长度
    //   if (!this.isMobile) {
    //     const viewportWidth = window.innerWidth;
    //     const filterBarElement = document.querySelector('.page-plp-left');
    //     let filterTopElement = document.querySelector('.slot-page-plp-top');
    //     let PRecommendElement;
    //     setTimeout(() => {
    //       PRecommendElement = document.querySelector('.recommend__all');
    //       if (viewportWidth < 1695) {
    //         handleElement2(PRecommendElement, true);
    //       } else {
    //         handleElement2(PRecommendElement, false);
    //       }
    //     }, 0);

    //     const handleElement = (element, type) => {
    //       if (element) {
    //         if (type) {
    //           element.style.paddingLeft = '7.5%';
    //           element.style.paddingRight = '7.5%';
    //         } else {
    //           element.style.paddingLeft = (viewportWidth - 1440) / 2 + 'px';
    //           element.style.paddingRight = (viewportWidth - 1440) / 2 + 'px';
    //         }
    //       }
    //     };
    //     const handleElement2 = (element, type) => {
    //       if (element) {
    //         if (type) {
    //           element.style.margin = '0 7.5%';
    //         } else {
    //           element.style.margin = '0 ' + (viewportWidth - 1440) / 2 + 'px';
    //         }
    //       }
    //     };

    //     // Function to apply styles to elements
    //     const applyStyles = () => {
    //       if (!filterBarElement && filterTopElement) {
    //         filterTopElement.style.marginBottom = '24px';
    //       }
    //       if (viewportWidth < 1695) {
    //         handleElement(filterBarElement, true);
    //         handleElement(filterTopElement, true);
    //         handleElement(PRecommendElement, true);
    //       } else {
    //         handleElement(filterBarElement, false);
    //         handleElement(filterTopElement, false);
    //         handleElement(PRecommendElement, false);
    //       }
    //       _this.showFilterStyle = true;
    //     };

    //     // Function to check for element existence and apply styles
    //     const checkAndApplyStyles = () => {
    //       if (filterTopElement) {
    //         applyStyles();
    //       } else {
    //         // If the element is not found, set up a MutationObserver
    //         const observer = new MutationObserver(() => {
    //           filterTopElement = document.querySelector('.slot-page-plp-top'); // 加载渲染元素有时效性，加个元素监听
    //           if (filterTopElement) {
    //             // If the element is found, disconnect the observer and apply styles
    //             observer.disconnect();
    //             applyStyles();
    //           }
    //         });

    //         // Configure and start the observer
    //         observer.observe(document.body, { childList: true, subtree: true });
    //       }
    //     };

    //     checkAndApplyStyles();
    //   } else {
    //     _this.showFilterStyle = true;
    //   }
    // },
    
    setFilterBarCeilingOption() {
      const _this = this;
      // 监听滚动事件，计算filterbar的吸顶样式
      this.observerScroll();
      const handleResize = () => {
        if (!_this.isMobile) {
          const viewportWidth = window.innerWidth;
          const filterBarElement = document.querySelector('.page-plp-left');
          const filterTopElement = document.querySelector('.slot-page-plp-top');
          const PRecommendElement = document.querySelector('.recommend__all');

          const handleElement = (element, type) => {
            if (element) {
              if (type) {
                element.style.paddingLeft = '7.5%';
                element.style.paddingRight = '7.5%';
              } else {
                element.style.paddingLeft = (viewportWidth - 1440) / 2 + 'px';
                element.style.paddingRight = (viewportWidth - 1440) / 2 + 'px';
              }
            }
          };

          const handleElement2 = (element, type) => {
            if (element) {
              if (type) {
                element.style.margin = '0 7.5%';
              } else {
                element.style.margin = '0 ' + (viewportWidth - 1440) / 2 + 'px';
              }
            }
          };

          // Function to apply styles to elements
          const applyStyles = () => {
            if (!filterBarElement && filterTopElement) {
              filterTopElement.style.marginBottom = '24px';
            }
            if (viewportWidth < 1695) {
              handleElement(filterBarElement, true);
              handleElement(filterTopElement, true);
              handleElement2(PRecommendElement, true);
            } else {
              handleElement(filterBarElement, false);
              handleElement(filterTopElement, false);
              handleElement2(PRecommendElement, false);
            }
            _this.showFilterStyle = true;
          };

          // Function to check for element existence and apply styles
          const checkAndApplyStyles = () => {
            if (filterTopElement) {
              applyStyles();
            } else {
              // If the element is not found, set up a MutationObserver
              const observer = new MutationObserver(() => {
                const newFilterTopElement = document.querySelector('.slot-page-plp-top');
                if (newFilterTopElement) {
                  // If the element is found, disconnect the observer and apply styles
                  observer.disconnect();
                  filterTopElement = newFilterTopElement;
                  applyStyles();
                }
              });
              // Configure and start the observer
              observer.observe(document.body, { childList: true, subtree: true });
            }
          };
          checkAndApplyStyles();
        } else {
          _this.showFilterStyle = true;
        }
      };
      // 初始调用
      handleResize();
      // 监听窗口尺寸变化
      window.addEventListener('resize', handleResize);
    },

    observerScroll() {
      document.addEventListener('scroll', this.listenerScroll);
    },
    listenerScroll() {
      const _this = this;
      const stickyHeader = document.querySelector('.page-plp-left');
      // 获取滚动位置
      const scrollPosition = window.scrollY;

      // 获取 top title 和 filterbar 元素
      const topTitleElement = _this.isMobile
        ? document.querySelector('.mobile_header-layer')
        : document.querySelector('.gt-header');
      const topPlpElement = document.querySelector('.slot-page-plp-top'); // 筛选栏的title：xx拖鞋 xx件商品
      // const topPlpElement2 = document.querySelector('.sp-swiper-container'); // 顶部slide图
      const topPlpElement2 = document.querySelector('.count-topAd-class'); // 顶部slide图

      // 获取 top title 的高度
      const topTitleHeight = topTitleElement?.offsetHeight || 0;
      const topPlpHeight = topPlpElement?.offsetHeight || 0;
      const topPlpHeight2 = topPlpElement2?.offsetHeight || 0;
      // if (!this.adPageTop.length && !this.isMobile && topPlpHeight > 100) {
      //   topPlpHeight = topPlpHeight - 100;
      // }
      // 设置触发吸顶的位置，例如 top title 底部位置
      const triggerPosition = (_this.isMobile ? topTitleHeight : 12) + topPlpHeight + topPlpHeight2;

      // 检查滚动位置是否超过了触发位置
      // console.log('触发了条件', scrollPosition, topTitleHeight, topPlpHeight, triggerPosition);
      if (stickyHeader) {
        if (scrollPosition >= triggerPosition) {
          // 满足触发条件，执行吸顶效果
          stickyHeader.style.boxShadow = ' 0px 4px 10px 0px rgba(0, 0, 0, 0.05)';

          this.$store.commit('setFilterSideStickyStataus', true);
        } else {
          // 未满足触发条件，取消吸顶效果
          stickyHeader.style.boxShadow = ' unset';
          this.$store.commit('setFilterSideStickyStataus', false);
        }
      }

      // 计算footer到顶部的距离
      // 选择类名为 "my-class" 的第一个元素
      // const element = document.querySelector('.footer');
      // const element2 = document.querySelector('.condition-product-list');

      // // 获取元素相对于视口的位置信息
      // const rect = element.getBoundingClientRect();

      // // 获取元素顶部与视口顶部的距离
      // const distanceFromViewportTop = rect.top;
      // if (distanceFromViewportTop < 136) {
      //   element2.style.top = '136px';
      // } else {
      //   element2.style.top = '0px';
      // }
      // // 输出距离
      // console.log('元素距离视口顶部的距离:', distanceFromViewportTop);
    }
  }
};
</script>

<style lang="scss">
.sp-grid-list__wrapper {
  overflow: visible;
  padding-bottom: 2px;
  // display: flex;
}

.page-layout_pc {
  .product-list-code {
    .plp-top_breadcrumb,
    .page-plp__top {
      display: none;
    }
  }
  .plp-top_breadcrumb {
    font-size: 12px;
    padding-top: 16px;
  }

  .page-search_title {
    color: var(--main-color-ua-dark-grey, #14141e);
    /* cn/pingfang/bold/32 */

    font-size: 32px;
    font-weight: 600;
    line-height: 38px; /* 118.75% */
  }
  .plp-top_breadcrumb {
    padding-top: 0px;
    font-size: 12px;
    font-weight: 400;
    width: 500px;
    max-width: 100vw;
    height: 64px;
    line-height: 64px;

    .el-breadcrumb__inner.is-link {
      color: #50505a;
      font-weight: 400;
    }
    .el-breadcrumb__item {
      &:last-child .el-breadcrumb__inner {
        color: #b4b4bf;
      }
    }
  }
}
.gt-plp-page {
  width: 100% !important;
  max-width: 100% !important;
  position: relative;
  .el-breadcrumb__separator {
    margin: 0 8px !important;
  }
}
@media (min-width: 1695px) {
  .gt-plp-page {
    width: 100% !important;
    max-width: 100% !important;
  }
}
.banner-item {
  max-width: calc(66% - 6px) !important;
  width: calc(66% - 6px);
  // margin-right: 8px !important;
  // max-width: calc((100% - 72px) * 0.75 + 48px) !important;
  // width: calc((100% - 72px) * 0.75 + 48px);
  // padding-left: 8px;
  // grid-column: span 2; /* 让横幅跨足两个div的位置 */
}
.sp-grid-list__wrapper {
  align-items: stretch;
  .waterfall__item > div:first-child {
    height: 100%;
  }
}
.plp-list_top {
  .plp-top_breadcrumb {
    padding-left: 12px;
    font-size: 12px;
    padding-top: 16px;
    display: flex;
    align-items: center;
  }
}
.page-search-empty {
  width: 100%;
  flex-shrink: 0;
  .search-box {
    margin-bottom: 80px;
    text-align: center;
    padding-top: 48px;
  }
  .plp-top_breadcrumb {
    display: flex;
    justify-content: center;
  }
  .search-box {
    .no-find {
      color: var(--main-color-ua-dark-grey, #14141e);
      text-align: center;

      /* cn/pingfang/regular/36 */
      font-family: PingFang SC;
      font-size: 36px;
      font-style: normal;
      font-weight: 400;
      line-height: 42px; /* 116.667% */
      text-transform: capitalize;
      margin-bottom: 16px;
      margin-top: 24px;
    }
    .again-search {
      color: var(--secondary-color-ua-cool-grey-04, #50505a);
      text-align: center;

      /* cn/pingfang/regular/24 */
      font-family: PingFang SC;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 30px; /* 125% */
      text-transform: capitalize;
    }
    .no-find-2 {
      color: var(--secondary-color-ua-cool-grey-03, #8c8c96);
      text-align: center;

      /* cn/pingfang/regular/20 */
      font-family: PingFang SC;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 26px; /* 130% */
      text-transform: capitalize;
    }
    .again-search-2 {
      color: var(--main-color-ua-dark-grey, #14141e);
      font-family: PingFang SC;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 26px;
      text-decoration-line: underline;
      text-transform: uppercase;
      cursor: pointer;
    }
    h3 {
      color: var(--main-color-ua-dark-grey, #14141e);
      text-align: center;

      /* cn/pingfang/regular/32 */

      font-size: 36px;
      font-style: normal;
      font-weight: 400;
      line-height: 38px; /* 118.75% */
    }
    h4 {
      color: var(--secondary-color-ua-cool-grey-04, #50505a);
      text-align: center;
      font-size: 24px;
      font-weight: 400;
      line-height: 22px; /* 137.5% */
      margin: 12px auto 24px auto;
    }
    p {
      color: var(--secondary-color-ua-cool-grey-04, #50505a);
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px; /* 150% */
      // margin-bottom: 8px;
    }
  }
}
.page-layout_mobile {
  .product-list-code {
    .plp-top_breadcrumb,
    .page-plp__top {
      display: none;
    }
  }
  .page-search-empty {
    padding: 0px;
    margin-top: 0px;
    padding-left: 20px;
    padding-right: 20px;
    .plp-dotted-line {
      border-top: 1px dotted var(--line-color-line-grey-01, #ddd);
      width: calc(100% - 40px);
      margin-left: 20px;
    }
    .search-box {
      h3 {
        color: var(--main-color-ua-dark-grey, #14141e);
        text-align: center;
        font-size: 16px !important;
        font-weight: 400;
        line-height: 26px; /* 130% */
        text-transform: uppercase;
      }
      h4 {
        color: var(--main-color-ua-dark-grey, #14141e);
        text-align: center;
        font-size: 12px !important;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
      }
      p {
        color: var(--secondary-color-ua-cool-grey-04, #50505a);
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px; /* 150% */
        span {
          display: block;
        }
      }
    }
    .product-recommend {
      padding: 0 0 24px !important;
    }
  }
  .sp-landing-productblock {
    .sp-plp-page {
      padding: 0;
    }
  }

  .sp-plp-page.condition-product-list {
    padding: 0px;
  }
}
.mobile-product-list-columns-2 {
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc(50% - 0.5px), 1fr)) !important;
    grid-gap: 0px !important;
    grid-row-gap: 0 !important; /* 设置行间距为0，即没有上下间距 */
    grid-column-gap: 1px !important; /* 设置列间距为1px，只有左右间距 */
  }
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper > .waterfall__item {
    max-width: 100% !important;
    min-width: 100% !important;
    overflow: hidden;
  }
}
.product-list-columns-2 {
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc((100% - 24px) / 2), 1fr)) !important;
    grid-gap: 24px !important;
  }
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper > .waterfall__item {
    // max-width: 50%;
    // min-width: 50%;
    max-width: 100% !important;
    min-width: 100% !important;
    // overflow: hidden;
    z-index: 11;
  }
}
.mobile-product-list-columns-3 {
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper {
    display: grid;
    // grid-template-columns: repeat(auto-fill, minmax(calc(33.3%), 1fr)) !important;
    grid-gap: 16px !important;
  }
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper > .waterfall__item {
    max-width: 100% !important;
    min-width: 100% !important;
    overflow: hidden;
  }
}
.product-list-columns-3 {
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc((100% - 48px) / 3), 1fr)) !important;
    grid-gap: 24px !important;
  }
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper > .waterfall__item {
    // max-width: calc(33.33%);
    // min-width: 33.3%;
    max-width: 100% !important;
    min-width: 100% !important;
    // overflow: hidden;
    z-index: 11;
  }
}
.mobile-product-list-columns-4 {
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc(25%), 1fr)) !important;
    grid-gap: 0px !important;
  }
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper > .waterfall__item {
    max-width: 100% !important;
    min-width: 100% !important;
    overflow: hidden;
  }
}
.product-list-columns-4 {
  // &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper {
  //   gap: 24px !important;
  // }
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc((100% - 72px) / 4), 1fr)) !important;
    grid-gap: 24px !important;
  }
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper > .waterfall__item {
    // max-width: 25%;
    // min-width: 25%;
    // max-width: calc((100% - 72px) * 0.25);
    // min-width: calc((100% - 72px) * 0.25);
    max-width: 100% !important;
    min-width: 100% !important;
    // overflow: hidden;
    z-index: 11;
  }
}
.mobile-product-list-columns-5 {
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc(20%), 1fr)) !important;
    grid-gap: 0px !important;
  }
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper > .waterfall__item {
    max-width: 100% !important;
    min-width: 100% !important;
    overflow: hidden;
  }
}
.product-list-columns-5 {
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper {
    display: grid;
    grid-template-columns: repeat(
      auto-fill,
      minmax(calc((100% - 96px) / 5), 1fr)
    ); /* 自动均分列，并设置最小宽度为*/
    grid-gap: 24px; /* 间距为 24px */
  }
  &.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper > .waterfall__item {
    // max-width: 20%;
    // min-width: 20%;
    max-width: 100%;
    min-width: 100%;
    // overflow: hidden;
    z-index: 11;
  }
}
.gt-plp-page.condition-product-list {
  padding-bottom: 60px;
}
.page-layout_mobile
  .product-list-columns-3
  .gt-page-plp_skeleton_product
  .sp-grid-list__wrapper
  .waterfall__item {
  border-left: 1px solid #fff;
  border-right: 1px solid #fff;
}
.other-null-svg {
  width: 96px;
  height: 96px;
}
@media (max-width: 1024px) {
  .other-null-svg {
    width: 48px;
    height: 48px;
  }
}
.load-more-main {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;
  padding-bottom: 0px;
  .load-more-text {
    color: var(--secondary-color-ua-cool-grey-03, #8c8c96);

    font-family: PingFang SC;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-transform: capitalize;
    margin-top: 4px;
  }
}
.plp-precommend {
  .hot-word-search__header {
    p {
      color: var(--main-color-ua-dark-grey, #14141e);

      /* cn/pingfang/bold/28 */
      font-family: PingFang SC;
      font-size: 28px !important;
      font-style: normal;
      font-weight: 600;
      line-height: 34px; /* 121.429% */
      text-transform: capitalize;
      text-align: left;
    }
  }
  .swiper-j_title {
    color: var(--main-color-ua-dark-grey, #14141e);

    /* cn/pingfang/bold/28 */
    font-family: PingFang SC;
    font-size: 28px !important;
    font-style: normal;
    font-weight: 600;
    line-height: 34px; /* 121.429% */
    text-transform: capitalize;
    text-align: left;
  }
  .hot-word-search {
    margin-bottom: 60px;
    .word {
      padding-bottom: 0px;
      margin-top: 32px;
    }
  }
  .product-recommend {
    padding-top: 0px;
  }
}
.page-search-empty-mobile {
  margin-top: -16px;
  .search-box {
    padding-top: 32px;
    margin-bottom: 48px;
    span {
      display: inline-block !important;
    }
    svg {
      width: 48px;
      height: 48px;
    }
    .no-find {
      margin-top: 12px;
      margin-bottom: 4px;
      color: var(--main-color-ua-dark-grey, #14141e) !important;
      font-size: 16px !important;
    }
    .again-search {
      color: var(--secondary-color-ua-cool-grey-04, #50505a) !important;
      font-size: 12px !important;
    }
  }
  .plp-precommend {
    .hot-word-search__header {
      p {
        color: var(--main-color-ua-dark-grey, #14141e);

        /* cn/pingfang/bold/14 */
        font-family: PingFang SC;
        font-size: 14px !important;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 142.857% */
        text-transform: capitalize;
        text-align: left;
      }
    }
    .swiper-j_title {
      color: var(--main-color-ua-dark-grey, #14141e);

      /* cn/pingfang/bold/14 */
      font-family: PingFang SC;
      font-size: 14px !important;
      font-style: normal;
      font-weight: 600;
      line-height: 20px; /* 142.857% */
      text-transform: capitalize;
      text-align: left;
      margin-bottom: 16px;
    }
    .hot-word-search {
      margin-bottom: 4px;
      .word {
        padding-bottom: 0px;
        margin-top: 16px;
      }
    }
    .product-recommend {
      padding-top: 0px;
    }
  }
}
.page-filter-empty-mobile {
  margin-top: -16px;
  .search-box {
    margin-top: 32px;
    margin-bottom: 48px;
    span {
      display: inline-block !important;
    }
    svg {
      width: 48px;
      height: 48px;
    }
    .no-find-2 {
      margin-top: 12px;
      margin-bottom: 4px;
      color: var(--main-color-ua-dark-grey, #8c8c96) !important;
      font-size: 14px !important;
      display: inline-block;
    }
    .again-search-2 {
      color: var(--secondary-color-ua-cool-grey-04, #14141e) !important;
      font-size: 14px !important;
      display: inline-block;
    }
  }
}
.sp-plp-page .gt-skeleton {
  // margin: 0px auto 0px !important;
  margin: 0 auto !important;
  max-width: 1440px !important;
  width: 85% !important;
  .sp-scroll-loading {
    width: 100% !important;
    max-width: 100% !important;
  }
}
</style>
<style lang="scss" layout="mobile">
.page-layout_mobile {
  .gt-plp-page {
    width: 100% !important;
  }
  @media (min-width: 1441px) {
    .gt-plp-page {
      width: 100% !important;
    }
  }
  .sp-grid-list__wrapper {
    background: var(--bg-for-product, #f7f7f7);
  }
  .waterfall__item {
    background: white;
  }
  .load-more-main {
    background: var(--bg-for-product, #f7f7f7);
    padding-top: 20px;
    padding-bottom: 32px;
    svg {
      width: 30px;
      height: 30px;
    }
    .load-more-text {
      color: var(--secondary-color-ua-cool-grey-03, #8c8c96);
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      text-transform: capitalize;
      margin-top: 0px;
    }
  }
  .sp-plp-page .gt-skeleton {
    width: 100% !important;
  }
  .gt-plp-page.condition-product-list {
    // margin-bottom: 30px;
    // background: var(--bg-for-product, #f7f7f7);
  }
  .mobile-product-list-columns-2.sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper {
    // grid-column-gap: unset !important;
  }
  .sp-grid-list__wrapper {
    // padding-bottom: 0;
  }
  .sp-plp-page .gt-page-plp_skeleton_product .sp-grid-list__wrapper {
    // padding-bottom: 30px;
    // background: var(--bg-for-product, #f7f7f7);
    background: var(--bg-for-product, #ffffff);
  }
}
</style>
